import sqliteInit from '@sqlite.org/sqlite-wasm';

const SCHEMA_VERSION = '1';

let dbInstance: any = null;
let ready: Promise<any> | null = null;

const SCHEMA_SQL = `
CREATE TABLE IF NOT EXISTS meta (
  key   TEXT PRIMARY KEY,
  value TEXT NOT NULL
);
CREATE TABLE IF NOT EXISTS months (
  ym       TEXT PRIMARY KEY,
  label    TEXT NOT NULL,
  created  TEXT NOT NULL
);
CREATE TABLE IF NOT EXISTS expenses (
  id        TEXT PRIMARY KEY,
  ym        TEXT NOT NULL,
  name      TEXT NOT NULL,
  category  TEXT NOT NULL,
  amount    REAL NOT NULL,
  notes     TEXT,
  paid      INTEGER NOT NULL DEFAULT 0,
  paid_at   TEXT,
  source    TEXT,
  FOREIGN KEY (ym) REFERENCES months(ym)
);
CREATE INDEX IF NOT EXISTS idx_expenses_ym ON expenses(ym);

CREATE TABLE IF NOT EXISTS transactions (
  id           TEXT PRIMARY KEY,
  bank         TEXT NOT NULL,
  account      TEXT,
  posted_at    TEXT NOT NULL,
  description  TEXT NOT NULL,
  amount_cents INTEGER NOT NULL,
  balance_cents INTEGER,
  category     TEXT,
  imported_at  TEXT NOT NULL,
  source_file  TEXT
);
CREATE INDEX IF NOT EXISTS idx_tx_posted ON transactions(posted_at);
CREATE INDEX IF NOT EXISTS idx_tx_desc   ON transactions(description);
`;

async function open(): Promise<any> {
  // @ts-ignore — the wasm bundle ships its own types
  const sqlite3 = await sqliteInit({ print: () => {}, printErr: () => {} });
  let db: any;
  if (sqlite3.oo1.OpfsDb) {
    db = new sqlite3.oo1.OpfsDb('/budget-tracker-v2.sqlite3', 'ct');
    console.info('[db] using OPFS storage');
  } else {
    console.warn('[db] OPFS not available, falling back to in-memory (state will not persist)');
    db = new sqlite3.oo1.DB(':memory:', 'ct');
  }
  db.exec(SCHEMA_SQL);
  const cur = db.exec({ sql: "SELECT value FROM meta WHERE key='schemaVersion'", returnValue: 'resultRows' });
  if (!cur || cur.length === 0) {
    db.exec({
      sql: "INSERT INTO meta(key,value) VALUES('schemaVersion', ?)",
      bind: [SCHEMA_VERSION],
    });
  }
  return db;
}

export function getDb(): Promise<any> {
  if (dbInstance) return Promise.resolve(dbInstance);
  if (!ready) {
    ready = open().then(db => {
      dbInstance = db;
      return db;
    });
  }
  return ready;
}

export function resetDbForTest() {
  dbInstance = null;
  ready = null;
}
